var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_195_2555",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0751953,
    y: 0.74469,
    width: 16.5248,
    height: 16.5248,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_195_2555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.64896 12.4497H9.02603V8.31846H7.64896V12.4497ZM8.3375 6.94139C8.53258 6.94139 8.69611 6.8754 8.82808 6.74343C8.96005 6.61147 9.02603 6.44794 9.02603 6.25285C9.02603 6.05777 8.96005 5.89424 8.82808 5.76227C8.69611 5.6303 8.53258 5.56432 8.3375 5.56432C8.14241 5.56432 7.97889 5.6303 7.84692 5.76227C7.71495 5.89424 7.64896 6.05777 7.64896 6.25285C7.64896 6.44794 7.71495 6.61147 7.84692 6.74343C7.97889 6.8754 8.14241 6.94139 8.3375 6.94139ZM8.3375 15.8923C7.38503 15.8923 6.48993 15.7116 5.65221 15.3501C4.81449 14.9886 4.08579 14.4981 3.46611 13.8784C2.84643 13.2587 2.35585 12.53 1.99437 11.6923C1.63289 10.8546 1.45215 9.95947 1.45215 9.00699C1.45215 8.05452 1.63289 7.15942 1.99437 6.32171C2.35585 5.48399 2.84643 4.75529 3.46611 4.13561C4.08579 3.51593 4.81449 3.02535 5.65221 2.66386C6.48993 2.30238 7.38503 2.12164 8.3375 2.12164C9.28997 2.12164 10.1851 2.30238 11.0228 2.66386C11.8605 3.02535 12.5892 3.51593 13.2089 4.13561C13.8286 4.75529 14.3191 5.48399 14.6806 6.32171C15.0421 7.15942 15.2228 8.05452 15.2228 9.00699C15.2228 9.95947 15.0421 10.8546 14.6806 11.6923C14.3191 12.53 13.8286 13.2587 13.2089 13.8784C12.5892 14.4981 11.8605 14.9886 11.0228 15.3501C10.1851 15.7116 9.28997 15.8923 8.3375 15.8923Z",
    fill: "#2979DF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionImg);
export default __webpack_public_path__ + "static/media/questionImg.f9fdced6a85fb908bfef2be1ffd3072e.svg";
export { ForwardRef as ReactComponent };